import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","display":"inline-block","max-width":"100%"} }
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "flex overflow-scroll w-[100%] h-[182px] mb-4 invisible-scroller"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-center min-w-[326px] mr-4 rounded-xl overflow-hidden ml-[34px]"
}
const _hoisted_8 = { class: "w-full h-full bg-black flex items-center justify-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "w-full h-full bg-black flex items-center justify-center" }
const _hoisted_11 = ["src", "onClick"]
const _hoisted_12 = { class: "px-[34px] mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "flex font-sourcesanspro-regular text-xs2 font-color-text-50 mb-4"
}
const _hoisted_14 = { class: "mr-2" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = {
  key: 1,
  class: "mb-2 font-sourcesanspro-semibold"
}

import { computed, ref, watch } from 'vue';
import { IonContent, IonIcon, IonSpinner } from '@ionic/vue';
import { useRoute } from 'vue-router';
import { chevronBackOutline, timeOutline } from 'ionicons/icons';
import { DateTime } from 'luxon';
import { useI18n } from 'vue-i18n';

import FavoriteButton from '@/shared/components/FavoriteButton.vue';
import FullScreenImage from '@/shared/components/ui/FullScreenImage.vue';
import RelatedContent from '@/shared/components/ui/RelatedContent.vue';
import ShareButton from '@/shared/components/ShareButton.vue';
import TopBar from '@/shared/components/TopBar.vue';
import UnsafeHtmlRenderer from '@/shared/components/UnsafeHtmlRenderer.vue';
import usePosts from '@/modules/news/composables/usePosts';
import useUtils from '@/shared/composables/useUtils';
import useTenant from '@/shared/composables/useTenant';
import { useCacheImage } from '@/shared/composables/useCacheImage';
import { useAuthStore } from '@/stores/auth/authStore';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'NewsDetailPage',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
// Reactively compute postId from route params and validate it's a valid number
const postId = computed(() => {
	const id = route.params.id;
	if (!id || typeof id !== 'string') {
		return NaN;
	}
	const numId = +id;
	return isNaN(numId) ? NaN : numId;
});
const { getPost, markPostAsViewed } = usePosts();
const authStore = useAuthStore();
// Only enable the query when postId is a valid number
const isValidPostId = computed(() => !isNaN(postId.value));
const { isFetchedPost, post } = getPost(postId, isValidPostId);
const { transformOembedToIframe } = useUtils();
const { getTenantConfigAndStyles } = useTenant();
const { showLoggedData } = getTenantConfigAndStyles();
const { loadImage } = useCacheImage();
const postImages = ref<string[]>([]);
const postMainImage = ref<string>('');
// Normalize returnTo to ensure it's a valid absolute path
const returnTo = computed(() => {
	const returnToValue = route.query.returnTo as string;
	if (!returnToValue) {
		return '/dashboard';
	}
	// If returnTo is 'feed', map it to '/dashboard' since there's no '/feed' route
	if (returnToValue === 'feed') {
		return '/dashboard';
	}
	// Ensure returnTo starts with '/' to make it an absolute path
	return returnToValue.startsWith('/') ? returnToValue : `/${returnToValue}`;
});

watch(
	post,
	async (post) => {
		if (post && !isNaN(postId.value) && authStore.isAuthenticated()) {
			markPostAsViewed(postId.value);
		}
		if (post?.main_image_url && !isNaN(postId.value)) {
			let postMainImg = post.main_image_url.split('/').pop();
			postMainImg = postMainImg ?? 'post';
			postMainImage.value = await loadImage(`post-${postId.value}-main-image`, postMainImg, post.main_image_url);
		}
		if (post?.images && !isNaN(postId.value)) {
			post.images.forEach(async (image: any, index: number) => {
				let postImg = image.image_url.split('/').pop();
				postImg = postImg ?? 'post';
				const imageUrl = await loadImage(`post-${postId.value}-image-${index}`, postImg, image.image_url);
				postImages.value.push(imageUrl);
			});
		}
	},
	{ immediate: true },
);

// Image handling
const fullScreenImage = ref('');
const openInFullScreen = ref(false);
const viewFullScreen = (image: string) => {
	fullScreenImage.value = image;
	openInFullScreen.value = true;
};

const onCloseImage = () => {
	openInFullScreen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      (openInFullScreen.value)
        ? (_openBlock(), _createBlock(FullScreenImage, {
            key: 0,
            fullScreenImage: fullScreenImage.value,
            onOnCloseImage: onCloseImage
          }, null, 8, ["fullScreenImage"]))
        : _createCommentVNode("", true),
      _createVNode(TopBar, { class: "px-[34px]" }, _createSlots({
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_button, {
              class: "w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full",
              shape: "round"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: returnTo.value,
                  class: "flex items-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(chevronBackOutline),
                      class: "ion-no-padding ion-no-margin text-black mr-[2px]"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 1
            })
          ])
        ]),
        center: _withCtx(() => [
          (_unref(post))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "flex justify-center w-full font-sourcesanspro-semibold text-l2 truncate",
                style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},
                title: _unref(post).title
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(post).title.length > 50 ? _unref(post).title.slice(0, 50) + '…' : _unref(post).title), 1)
              ], 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (_unref(post))
          ? {
              name: "right",
              fn: _withCtx(() => [
                (_unref(showLoggedData)())
                  ? (_openBlock(), _createBlock(FavoriteButton, {
                      key: 0,
                      id: _unref(post).id,
                      favorite: _unref(post).is_favorite,
                      type: _unref(post).type
                    }, null, 8, ["id", "favorite", "type"]))
                  : _createCommentVNode("", true),
                _createVNode(ShareButton, {
                  id: _unref(post).id,
                  title: _unref(post).title,
                  type: "news"
                }, null, 8, ["id", "title"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1024),
      (!_unref(isFetchedPost) && isValidPostId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(IonSpinner), { name: "dots" })
          ]))
        : _createCommentVNode("", true),
      (_unref(post) && _unref(isFetchedPost))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (postMainImage.value || postImages.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (postMainImage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("img", {
                            src: postMainImage.value,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (viewFullScreen(postMainImage.value))),
                            class: "object-contain w-full h-full",
                            style: {"background-color":"black"}
                          }, null, 8, _hoisted_9)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postImages.value, (image, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: _normalizeClass(["flex items-center min-w-[326px] mr-4 rounded-xl overflow-hidden", [{ 'ml-[34px]': idx === 0 }]])
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: image,
                          onClick: ($event: any) => (viewFullScreen(image)),
                          class: "object-contain w-full h-full",
                          style: {"background-color":"black"}
                        }, null, 8, _hoisted_11)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              (_unref(post).show_metadata !== false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(DateTime).fromISO(_unref(post)?.created_at).toFormat('dd MMMM yyyy')), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_unref(IonIcon), {
                        class: "mr-1 text-m2 font-color-text-50",
                        icon: _unref(timeOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_unref(DateTime).fromISO(_unref(post)?.created_at).toFormat('HH:mm')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(UnsafeHtmlRenderer, {
                html: _unref(transformOembedToIframe)(_unref(post).content),
                unsafe: Boolean(_unref(post).full_html),
                class: "font-sourcesanspro-regular text-base2 mb-4 font-white"
              }, null, 8, ["html", "unsafe"])
            ]),
            (_unref(post).events.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(RelatedContent, {
                    title: _unref(t)('components.related_content.title_events'),
                    contents: 
						_unref(post).events.map((event) => {
							return {
								'link': `/events/${event.id}`,
								'src': event.main_image_url,
								'title': event.name,
								'subtitle': '',
							};
						})
					
                  }, null, 8, ["title", "contents"])
                ]))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-[100px] mb-4" }, " ", -1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})